import React from "react";
import { FaDonate, FaHandsHelping } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import "./CTA.css";

const CTA = () => {
  const navigate = useNavigate();

  return (
    <section className="cta-section-home" id="cta-section">
      <div className="cta-container-home">
        <h2 className="cta-title-home" data-aos="fade-up">
          Join Us in Making a Difference
        </h2>
        <p className="cta-desc-home" data-aos="fade-up" data-aos-delay="100">
          Be part of our journey to empower communities, transform lives, and create lasting impact.
        </p>
        <div className="cta-buttons-home" data-aos="fade-up" data-aos-delay="200">
          <button
            className="cta-btn-primary-home"
            onClick={() => navigate("/donate")}
          >
            <FaDonate className="cta-icon-home" /> Donate Now
          </button>
          <button
            className="cta-btn-secondary-home"
            onClick={() => navigate("/volunteer")}
          >
            <FaHandsHelping className="cta-icon-home" /> Volunteer
          </button>
        </div>
      </div>
    </section>
  );
};

export default CTA;
